import React from 'react';
import { Input } from 'twyne-new.ui';

import FormComponent from './FormComponent';

export default class InputForm extends FormComponent {
  static Pure = ({ onChange, ...props }) => {
    return <Input {...props}
      onChange={evt => onChange(evt.target.value)}
    />
  }
}